import { filterSettingsVoicesByProvider } from "../actions/playMessage";

export function bindVoicePreviewHandlers() {
    const selector = '.chat-settings-single .btn-preview-voice';

    // Delegate from the document so previews inserted after initialization work too.
    jQuery(document).off('click.voice', selector).on('click.voice', selector, function () {
        const $button = jQuery(this);
        const audioUrl = $button.attr('data-preview-url');

        // If already playing the same audio, stop it
        if (window.growtypeChatSettingsPreviewVoice &&
            !window.growtypeChatSettingsPreviewVoice.paused &&
            window.growtypeChatSettingsPreviewVoice.src === audioUrl) {
            window.growtypeChatSettingsPreviewVoice.pause();
            window.growtypeChatSettingsPreviewVoice.currentTime = 0;
            window.growtypeChatSettingsPreviewVoice = null;
            $button.removeClass('is-playing');
            return;
        }

        // Stop any other audio
        if (window.growtypeChatSettingsPreviewVoice) {
            stopVoicePreview();
        }

        // Create and play new audio
        const audio = new Audio(audioUrl);
        window.growtypeChatSettingsPreviewVoice = audio;
        $button.addClass('is-playing');

        audio.addEventListener('ended', () => {
            $button.removeClass('is-playing');
            window.growtypeChatSettingsPreviewVoice = null;
        });

        audio.addEventListener('pause', () => $button.removeClass('is-playing'));

        audio.play().catch(err => {
            console.error("Audio playback failed:", err);
            $button.removeClass('is-playing');
            window.growtypeChatSettingsPreviewVoice = null;
        });
    });
}

export function bindVoiceSelectPreviewHandlers() {
    const selector = '.chat-settings-single[data-type="voice"] select';

    jQuery(document).off('change.voicePreview', selector).on('change.voicePreview', selector, function () {
        const $select = jQuery(this);
        const $settingsSingle = $select.closest('.chat-settings-single[data-type="voice"]');
        const previewUrl = $select.find('option:selected').attr('data-preview-url') || '';
        const $previewButton = $settingsSingle.find('.btn-preview-voice');

        $previewButton.attr('data-preview-url', previewUrl);
        filterSettingsVoicesByProvider($select);

        if ($settingsSingle.is(':visible') && previewUrl) {
            stopVoicePreview();
            setTimeout(() => $previewButton.trigger('click'), 100);
        }
    });
}

export function stopVoicePreview() {
    if (window.growtypeChatSettingsPreviewVoice) {
        window.growtypeChatSettingsPreviewVoice.pause();
        window.growtypeChatSettingsPreviewVoice.currentTime = 0;
        jQuery('.btn-preview-voice').removeClass('is-playing');
    }
}
